import { withNamespaces } from 'react-i18next';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Spinner,
} from 'reactstrap';

const DisconnectMicrosoftModal = ({
    t,
    isOpen,
    toggle,
    isLoading,
    onConfirm,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
        >
            <ModalHeader toggle={toggle}>
                {t('Disconnect Microsoft mailbox?')}
            </ModalHeader>
            <ModalBody>
                {t('Disconnecting will stop inbox sync until you Connect Microsoft again. Sending can still use SMTP password.')}
            </ModalBody>
            <ModalFooter>
                <Button
                    type="button"
                    color="secondary"
                    onClick={toggle}
                    disabled={isLoading}
                >
                    {t('Cancel')}
                </Button>
                <Button
                    type="button"
                    color="danger"
                    onClick={onConfirm}
                    disabled={isLoading}
                >
                    {isLoading && (
                        <Spinner size="sm" color="white" className="me-2" />
                    )}
                    {t('Disconnect Microsoft')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(DisconnectMicrosoftModal);
